import React from 'react';
import { RegisterConfigPage } from './RegisterConfigPage';

export const RiskConfigPage: React.FC = () => {
  return <RegisterConfigPage kind="risk" />;
};
